import { Box, Button, NoticeBox, Tag, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Callout from 'modules/core/components/Callout'
import i18n from 'modules/core/lib/i18n'

import {
  FixedBreakInputs,
  FlexibleBreakInputs,
  SemiFlexibleBreakInputs,
} from 'modules/shift_management/components/ShiftManagement/PlannedBreaks/FormInputs'
import type PlannedBreakForm from 'modules/shift_management/lib/forms/PlannedBreakForm'

import BreakTypeSelector from 'modules/shift_management/components/ShiftManagement/PlannedBreaksSelector/BreakTypeSelector'

interface Props {
  plannedBreakForms: PlannedBreakForm[]
  onDelete: (form: PlannedBreakForm) => void
  newVersion: boolean
}

const PlannedBreaks = ({ plannedBreakForms, onDelete, newVersion }: Props) => {
  const sortedBreakForms = plannedBreakForms.sort((a, b) => a.get('id').value - b.get('id').value)
  return (
    <>
      {sortedBreakForms.map((form, index) => {
        if (!!form.isArchived && !newVersion) {
          return (
            <Box key={index} flexDirection="row" gap="s16">
              <NoticeBox
                message={i18n.t('shift_management.planned_breaks.archived.warning_custom')}
                borderRadius={{ all: 'abs008' }}
              />
              <Box>
                <Button type="secondary" onClick={() => onDelete(form)} iconName="delete" />
              </Box>
            </Box>
          )
        }

        return (
          // FIXME: We shouldn't be using indexes as keys, but can't use id as key since new forms won't have one :_D
          <Box
            key={index}
            borderRadius={{ all: 'abs016' }}
            border={{ all: { width: 's1', style: 'solid', color: 'grey400' } }}
            background="grey100"
          >
            <Box
              flexDirection="row"
              justifyContent="spaceBetween"
              padding="s16"
              borderRadius={{ all: 'abs016' }}
              border={{ bottom: { width: 's1', style: 'solid', color: 'grey400' } }}
              background="grey000White"
            >
              {form.isArchived ? (
                <Box flexDirection="row" gap="s16">
                  <Callout
                    type="info"
                    description={i18n.t('shift_management.planned_breaks.archived.was_deleted', {
                      name: form.get('break_configuration.name').value,
                    })}
                    hideIcon
                    compact
                  />
                  <Box justifyContent="center">
                    <Button type="secondary" onClick={() => onDelete(form)} iconName="delete" />
                  </Box>
                </Box>
              ) : (
                <>
                  <Box gap="s8">
                    <Text.Normal size="200" weight="medium" color="grey800">
                      {form.get('break_configuration.name').value}
                    </Text.Normal>
                    <Box width="fit-content">
                      <Tag type={form.isPaid ? Tag.Types.lime : Tag.Types.malibu}>
                        {form.isPaid
                          ? i18n.t('company_settings.time.breaks.paid')
                          : i18n.t('company_settings.time.breaks.unpaid')}
                      </Tag>
                    </Box>
                  </Box>

                  <Box>
                    <Button type="secondary" onClick={() => onDelete(form)} iconName="delete" />
                  </Box>
                </>
              )}
            </Box>
            {!form.isArchived && (
              <Box alignItems="center" padding="s16" gap="s12">
                <BreakTypeSelector form={form} />
                {form.isFlexible && <FlexibleBreakInputs form={form} newVersion />}
                {form.isFixed && <FixedBreakInputs form={form} newVersion />}
                {form.isSemiFlexible && <SemiFlexibleBreakInputs form={form} newVersion />}
              </Box>
            )}
          </Box>
        )
      })}
    </>
  )
}
export default observer(PlannedBreaks)
